module.exports = __webpack_public_path__ + "img/Michal Prevratil.57ad4b6d.jpg";